import { useTheme } from "next-themes";
import IntegrationCard from "./IntegrationCard";
import { CardTitle } from "../../../components/ui/card";
import { useCallback, useEffect, useState } from "react";
import { API, get } from "../../../config";
import { useTrust } from "../../../lib/context/TrustContext";
import Spin from "../../../components/Spin";
const Integration = () => {
  const { theme, systemTheme } = useTheme();
  const [loading, setLoading] = useState(false);
  const { trustId } = useTrust();
  const [integrations, setIntegrations] = useState([]);

  const FetchIntegrationDetails = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await get(
        `${API.INTEGRATION_DETAILS}?trust_id=${trustId}`
      );
      setIntegrations(data?.data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      setIntegrations([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trustId]);

  useEffect(() => {
    FetchIntegrationDetails();
  }, [FetchIntegrationDetails]);

  return (
    <>
      {loading && <Spin expand={true} />}
      <div className="p-6 space-y-10 relative">
        {integrations.map(
          (section, idx) =>
            (section?.can_create || !("can_create" in section)) && (
              <div key={idx}>
                {(systemTheme === "dark" && theme === "system") ||
                theme === "dark" ? (
                  <CardTitle className="mb-12">{section.section}</CardTitle>
                ) : (
                  <h2 className="text-xl font-semibold text-webPrimary mb-12">
                    {section.section}
                  </h2>
                )}
                <div className="flex flex-wrap gap-6">
                  {section.items.map((item, i) => (
                    <IntegrationCard
                      key={i}
                      {...item}
                      trustId={trustId}
                      setLoading={setLoading}
                      loading={loading}
                      fetchIntegration={FetchIntegrationDetails}
                    />
                  ))}
                </div>
              </div>
            )
        )}
      </div>
    </>
  );
};

export default Integration;
